/* eslint-disable max-lines */
import { getFeature, isFeature } from 'Cloud/Application/FeaturesEs6';
import { ReactComponent as BenefitLabel } from 'img/quota-landing/aiTariff/benefitLabel.svg';
import { ReactComponent as Icon20Stars } from 'img/quota-landing/aiTariff/stars_20.svg';
import React, { type ReactElement } from 'react';
import {
    aiTariffAbEnabled,
    aiTariffAbVariantB,
    aiTariffAbVariantC1,
    aiTariffAbVariantC2,
} from 'reactApp/appHelpers/featuresHelpers/features/aiTariff';
import { isFeatureNeurofilterPromo } from 'reactApp/appHelpers/featuresHelpers/features/neurofilter';
import type { ETabsName } from 'reactApp/ui/TariffSectionNew/TariffSection.constants';

export const multiTariffShow = isFeature('multi-tariff-show');

export const multiTariffKeepOrderAsInFeature = isFeature('multi-tariff-keep-list-order');

export const multiTariffInitTab = getFeature('multi-tariff-init-tab') || 'basic';

export const multiTariffInitPeriodTab: ETabsName | undefined = getFeature('multi-tariff-init-period-tab');

export const familyByOptionsSwitcherState = isFeature('family-by-options-switcher-state');

export const familyByOptionsFeature = isFeature('family-by-options-feature');
export const familyByOptionsEnterTooltipFeature = isFeature('family-by-options-enter-tooltip');

type TariffList = {
    year: string[];
    month: string[];
};

export const multiTariffBasicTariffList: TariffList = getFeature('multi-tariff-basic-tariff-list') || {
    year: [
        'W2TB_1y_blackfriday_2023_discount_single_quota_cloud',
        'W1TB_1y_blackfriday_2023_discount_single_quota_cloud',
        'W512GB_1y_blackfriday_2023_discount_single_quota_cloud',
        'W256GB_1y_blackfriday_2023_discount_single_quota_cloud',
    ],
    month: [
        'W2T1m_single_quota_2022_cloud',
        'W1T1m_single_quota_2022_cloud',
        'W512G1m_single_quota_2022_cloud',
        'W256G1m_single_quota_2022_cloud',
    ],
};

export const multiTariffAdvancedTariffList: TariffList = getFeature('multi-tariff-advanced-tariff-list') || {
    year: [
        'W256GB_1y_landing_segmentation_discount',
        'W512GB_1y_landing_segmentation_discount',
        'W1TB_1y_landing_segmentation_discount',
        'W2TB_1y_landing_segmentation_discount',
    ],
    month: [
        'W256GB_1m_landing_segmentation_discount',
        'W512GB_1m_landing_segmentation_discount',
        'W1TB_1m_landing_segmentation_discount',
        'W2TB_1m_landing_segmentation_discount',
    ],
};

export const multiTariffFamilyTariff = getFeature('multi-tariff-family-tariff') || 'W1TB_family_features_a';

export interface BenefitData {
    id: string;
    name: string;
    free: boolean;
    paid: boolean;
    advanced: boolean;
    family?: boolean;
    isNew?: boolean;
    isNeuro?: boolean;
    icon?: ReactElement;
    // Для подстветки фона нескольких фич одним блоком
    firstSelection?: boolean;
    lastSelection?: boolean;
    isSelection?: boolean;
    vigbo?: boolean;
}

export const multiTariffCloudBenefits: BenefitData[] = [
    {
        id: 'docs',
        name: 'Редактирование документов',
        free: true,
        paid: true,
        advanced: true,
        family: true,
    },
    {
        id: 'autosave',
        name: 'Автосохранение файлов с телефона в Облако',
        free: true,
        paid: true,
        advanced: true,
        family: true,
    },
    {
        id: 'size',
        name: 'Дополнительное место для файлов',
        free: false,
        paid: true,
        advanced: true,
        family: true,
    },
    {
        id: 'infinity',
        name: 'Безлимитная автозагрузка фото и видео с телефона',
        free: false,
        paid: true,
        advanced: true,
        family: true,
    },
    {
        id: 'support',
        name: 'Приоритетная поддержка',
        free: false,
        paid: true,
        advanced: true,
        family: true,
    },
    {
        id: 'ad',
        // eslint-disable-next-line sonarjs/no-duplicate-string
        name: 'Без рекламы',
        free: false,
        paid: false,
        advanced: true,
        family: true,
    },
    {
        id: 'upload',
        name: 'Загрузка файлов до 100 ГБ в Облако',
        free: false,
        paid: false,
        advanced: true,
        family: true,
    },
    {
        id: 'autodelete',
        name: 'Таймер для автоудаления отправленных папок',
        free: false,
        paid: false,
        advanced: true,
        family: true,
    },
    {
        id: 'themed-publick',
        name: 'Выбор оформления для совместных папок',
        free: false,
        paid: false,
        advanced: true,
        family: true,
    },
    {
        id: 'password',
        name: 'Пароль для совместных папок в веб-версии',
        free: false,
        paid: false,
        advanced: true,
        family: true,
    },
    {
        id: 'family',
        name: 'Можно делиться памятью ещё с 3 участниками',
        free: false,
        paid: false,
        advanced: !familyByOptionsFeature,
        family: true,
    },
    {
        id: 'family-folders',
        name: 'Семейные папки с общим доступом',
        free: false,
        paid: false,
        advanced: false,
        family: true,
        isNew: true,
    },
    {
        id: 'family-albums',
        name: 'Семейные альбомы с общим доступом',
        free: false,
        paid: false,
        advanced: false,
        family: true,
        isNew: true,
    },
    {
        id: 'benefits',
        name: 'Возможности тарифа у всех в подписке',
        free: false,
        paid: false,
        advanced: false,
        family: true,
        isNew: true,
    },
];

export const multiTariffCloudBenefitsVigbo: BenefitData[] = [
    {
        id: 'docs',
        name: 'Редактирование документов',
        free: true,
        paid: true,
        advanced: true,
        family: true,
        vigbo: true,
    },
    {
        id: 'autosave',
        name: 'Автосохранение файлов с телефона в Облако',
        free: true,
        paid: true,
        advanced: true,
        family: true,
        vigbo: true,
    },
    {
        id: 'size',
        name: 'Дополнительное место для файлов',
        free: false,
        paid: true,
        advanced: true,
        family: true,
        vigbo: true,
    },
    {
        id: 'infinity',
        name: 'Безлимитная автозагрузка фото и видео с телефона',
        free: false,
        paid: true,
        advanced: true,
        family: true,
        vigbo: true,
    },
    {
        id: 'support',
        name: 'Приоритетная поддержка',
        free: false,
        paid: true,
        advanced: true,
        family: true,
        vigbo: true,
    },
    {
        id: 'ad',
        name: 'Без рекламы',
        free: false,
        paid: false,
        advanced: true,
        family: true,
        vigbo: true,
    },
    {
        id: 'upload',
        name: 'Загрузка файлов до 100 ГБ в Облако',
        free: false,
        paid: false,
        advanced: true,
        family: true,
        vigbo: true,
    },
    {
        id: 'autodelete',
        name: 'Таймер для автоудаления отправленных папок',
        free: false,
        paid: false,
        advanced: true,
        family: true,
        vigbo: true,
    },
    {
        id: 'themed-publick',
        name: 'Выбор оформления для совместных папок',
        free: false,
        paid: false,
        advanced: true,
        family: true,
        vigbo: true,
    },
    {
        id: 'password',
        name: 'Пароль для совместных папок в веб-версии',
        free: false,
        paid: false,
        advanced: true,
        family: true,
        vigbo: true,
    },
    {
        id: 'family',
        name: 'Можно делиться памятью ещё с 3 участниками',
        free: false,
        paid: false,
        advanced: !familyByOptionsFeature,
        family: true,
        vigbo: true,
    },
    {
        id: 'family-folders',
        name: 'Семейные папки с общим доступом',
        free: false,
        paid: false,
        advanced: false,
        family: true,
        isNew: true,
        vigbo: false,
    },
    {
        id: 'family-albums',
        name: 'Семейные альбомы с общим доступом',
        free: false,
        paid: false,
        advanced: false,
        family: true,
        isNew: true,
        vigbo: false,
    },
    {
        id: 'benefits',
        name: 'Возможности тарифа у всех в подписке',
        free: false,
        paid: false,
        advanced: false,
        family: true,
        isNew: true,
        vigbo: false,
    },
    {
        id: 'create-vigbo',
        name: 'Создание галерей Vigbo',
        free: false,
        paid: false,
        advanced: false,
        family: false,
        isNew: true,
        vigbo: true,
    },
    {
        id: 'func-vigbo',
        name: 'Функция ретуши в Vigbo',
        free: false,
        paid: false,
        advanced: false,
        family: false,
        isNew: true,
        vigbo: true,
    },
];

export const multiTariffMailBenefits: BenefitData[] = [
    {
        id: 'virus',
        name: 'Проверка вложений антивирусом',
        free: true,
        paid: true,
        advanced: true,
        family: true,
    },
    {
        id: 'mail-size',
        name: 'Дополнительное место для писем',
        free: false,
        paid: true,
        advanced: true,
        family: true,
    },
    {
        id: 'ad',
        name: 'Без рекламы',
        free: false,
        paid: false,
        advanced: true,
        family: true,
    },
    {
        id: 'send',
        name: 'Отправка вложений до 100 ГБ в письмах',
        free: false,
        paid: false,
        advanced: true,
        family: true,
    },
    {
        id: 'cancel',
        name: 'Отмена отправки писем в течение 30 секунд',
        free: false,
        paid: false,
        advanced: true,
        family: true,
    },
    {
        id: 'notification',
        name: 'Уведомления о прочтении ваших писем',
        free: false,
        paid: false,
        advanced: true,
        family: true,
    },
    {
        id: 'widgets',
        name: 'Полезные виджеты Календаря и Задач всегда на виду',
        free: false,
        paid: false,
        advanced: true,
        family: true,
        isNew: false,
    },
];

if (isFeatureNeurofilterPromo && !aiTariffAbEnabled) {
    multiTariffMailBenefits.push({
        id: 'neuroassistant',
        name: 'Нейропомощник в веб-версии Почты',
        free: false,
        paid: false,
        advanced: true,
        family: true,
        isNew: true,
    });
}

export const multiTariffMailBenefitsVigbo: BenefitData[] = [
    {
        id: 'virus',
        name: 'Проверка вложений антивирусом',
        free: true,
        paid: true,
        advanced: true,
        family: true,
        vigbo: true,
    },
    {
        id: 'mail-size',
        name: 'Дополнительное место для писем',
        free: false,
        paid: true,
        advanced: true,
        family: true,
        vigbo: true,
    },
    {
        id: 'ad',
        name: 'Без рекламы',
        free: false,
        paid: false,
        advanced: true,
        family: true,
        vigbo: true,
    },
    {
        id: 'send',
        name: 'Отправка вложений до 100 ГБ в письмах',
        free: false,
        paid: false,
        advanced: true,
        family: true,
        vigbo: true,
    },
    {
        id: 'cancel',
        name: 'Отмена отправки писем в течение 30 секунд',
        free: false,
        paid: false,
        advanced: true,
        family: true,
        vigbo: true,
    },
    {
        id: 'notification',
        name: 'Уведомления о прочтении ваших писем',
        free: false,
        paid: false,
        advanced: true,
        family: true,
        vigbo: true,
    },
    {
        id: 'widgets',
        name: 'Полезные виджеты Календаря и Задач всегда на виду',
        free: false,
        paid: false,
        advanced: true,
        family: true,
        vigbo: true,
    },
];

const familyByOptionsMonthTariffs = getFeature('family-by-options-month-tariffs') || [
    'W256GB_1m_family_features_discount_3m',
    'W512GB_1m_family_features_discount_3m',
    'W1TB_1m_family_features_a',
    'W2TB_1m_family_features_discount_3m',
];

const familyByOptionsYearTariffs = getFeature('family-by-options-year-tariffs') || [
    'W256GB_1y_family_features_discount',
    'W512GB_1y_family_features_discount',
    'W1TB_1y_family_features_a',
    'W2TB_1y_family_features_discount',
];

export const familyByOptionsTariffs = {
    year: familyByOptionsYearTariffs,
    month: familyByOptionsMonthTariffs,
};

export const familyByOptionsUpsaleEnable = isFeature('family-by-options-upsale-enable');
export const familyByOptionsUpsaleTariffs = {
    year: getFeature('family-by-options-upsale-tariffs') || familyByOptionsYearTariffs,
    month: [],
};

export const vigboTariffListEnabled = isFeature('vigbo-tariff-list-enabled');
export const vigboTariffTooltipEnabled = isFeature('vigbo-tariff-tooltip-enable');

export const multiTariffVigboTariffList: TariffList = getFeature('multi-tariff-advanced-tariff-list') || {
    year: ['W256GB_1y_vigbo_discount', 'W1TB_1y_vigbo_discount', 'W2TB_1y_vigbo_discount', 'W4TB_1y_vigbo_discount'],
    month: ['W256GB_1m_vigbo_discount', 'W1TB_1m_vigbo_discount', 'W2TB_1m_vigbo_discount', 'W4TB_1m_vigbo_discount'],
};

export const aiTariffAbVariantBCloudBenefits: BenefitData[] = [
    {
        id: 'duplicate',
        name: 'Удаление дубликатов',
        free: false,
        paid: false,
        family: false,
        advanced: !aiTariffAbVariantB,
        isNeuro: true,
        icon: aiTariffAbVariantB ? <Icon20Stars /> : <BenefitLabel />,
        firstSelection: aiTariffAbVariantC1 || aiTariffAbVariantC2,
        // eslint-disable-next-line max-lines
    },
    {
        id: 'swipes',
        name: 'Разбор фото свайпами',
        free: false,
        // eslint-disable-next-line max-lines
        paid: false,
        family: false,
        advanced: !aiTariffAbVariantB,
        isNeuro: true,
        icon: aiTariffAbVariantB ? <Icon20Stars /> : <BenefitLabel />,
        isSelection: aiTariffAbVariantC1 || aiTariffAbVariantC2,
    },
    {
        id: 'faces',
        name: 'Определение лиц на фото',
        free: false,
        paid: false,
        family: false,
        advanced: !aiTariffAbVariantB,
        isNeuro: true,
        icon: aiTariffAbVariantB ? <Icon20Stars /> : <BenefitLabel />,
        lastSelection: aiTariffAbVariantC1 || aiTariffAbVariantC2,
    },
];

export const aiTariffAbVariantBMailBenefits: BenefitData[] = [
    {
        id: 'ailetterstyle',
        name: 'Генерация и изменение стиля писем',
        free: false,
        paid: false,
        family: false,
        advanced: !aiTariffAbVariantB,
        isNeuro: true,
        icon: aiTariffAbVariantB ? <Icon20Stars /> : <BenefitLabel />,
        firstSelection: aiTariffAbVariantC1 || aiTariffAbVariantC2,
    },
    {
        id: 'aisummary',
        name: 'Краткий пересказ писем',
        free: false,
        paid: false,
        family: false,
        advanced: !aiTariffAbVariantB,
        isNeuro: true,
        icon: aiTariffAbVariantB ? <Icon20Stars /> : <BenefitLabel />,
        isSelection: aiTariffAbVariantC1 || aiTariffAbVariantC2,
    },
    {
        id: 'neuroassisstant',
        name: 'Нейропомощник в Почте в веб-версии',
        free: false,
        paid: false,
        family: false,
        advanced: !aiTariffAbVariantB,
        isNeuro: true,
        icon: aiTariffAbVariantB ? <Icon20Stars /> : <BenefitLabel />,
        isSelection: aiTariffAbVariantC1 || aiTariffAbVariantC2,
    },
    {
        id: 'antispam',
        name: 'Антиспам алгоритм',
        free: false,
        paid: false,
        family: false,
        advanced: !aiTariffAbVariantB,
        isNeuro: true,
        icon: aiTariffAbVariantB ? <Icon20Stars /> : <BenefitLabel />,
        lastSelection: aiTariffAbVariantC1 || aiTariffAbVariantC2,
    },
];

export const multiTariffFamilyTariffListEnable: boolean = isFeature('multi-tariff-family-tariff-list-enable');
export const multiTariffFamilyTariffList: TariffList = getFeature('multi-tariff-family-tariff-list') || {
    year: [
        'W256GB_1y_family_features_discount',
        'W512GB_1y_family_features_discount',
        'W1TB_1y_family_features_a',
        'W2TB_1y_family_features_discount',
    ],
    month: [
        'W256GB_1m_family_features_discount_3m',
        'W512GB_1m_family_features_discount_3m',
        'W1TB_1m_family_features_a',
        'W2TB_1m_family_features_discount_3m',
    ],
};
